import { AppContext } from '@ctsu/loader';
import { useCallback, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import bindLogger from 'helpers/BindLogger';
import { checkQueuedProcessJobs } from 'actions/cirb/QueuedProcessAction';
import { getIsCheckForQueuedItemsSelector } from 'reducers/cirb';

let queueStatusTimeoutId;
const INTERVAL_TIME = 1000 * 60; // 1 min

function CheckQueuedStatus() {
  const dispatch = useDispatch();
  const actions = bindActionCreators(
    {
      checkQueuedProcessJobs
    },
    dispatch
  );
  const checkQueuedItems = useSelector(getIsCheckForQueuedItemsSelector);

  // get the data from the use session
  const context = useContext(AppContext);
  const { session } = context;

  const clearIntervalTimer = () => {
    if (queueStatusTimeoutId) {
      clearInterval(queueStatusTimeoutId);
    }
  };

  const checkQueueStatusApi = useCallback(() => {
    if (session) {
      bindLogger(actions.checkQueuedProcessJobs, context)(session.username).subscribe();
    }
  }, [context, session, actions.checkQueuedProcessJobs]);

  // check api on component mount
  useEffect(() => {
    checkQueueStatusApi();
  }, [checkQueueStatusApi]);

  useEffect(() => {
    // stop if not has session or record.
    if (!session || !checkQueuedItems) {
      clearIntervalTimer();
      // api if has record.
    } else if (checkQueuedItems) {
      checkQueueStatusApi();
      clearIntervalTimer();
      queueStatusTimeoutId = setInterval(checkQueueStatusApi, INTERVAL_TIME);
    }
    return () => clearIntervalTimer();
  }, [dispatch, checkQueueStatusApi, checkQueuedItems, session]);

  return null;
}

export default CheckQueuedStatus;
